const customEnglishMessages = {
    'configuration': {
        cfa_method_requested: 'CFA Method: Requested',
        cfa_method_waived: 'CFA Method: Waived',
        general: "General",
        fabric: "Fabric",
        pdfs: "PDFs",
        shipping_method_regular: 'Shipping Method: Regular',
        shipping_method_expedited: 'Shipping Method: Expedited',
        shipping_method_own_account: 'Shipping Method: Own Account',
        shipping_method_free: 'Shipping Method: Free',
        environment: 'Environment',
        social: "Social",
        contact: "Contact",
        email: "Email",
        field: {
            name: "Name",
            description: "Description",
            shipping_method: "Shipping Method",
            searchable_attributes: "Searchable Attributes",
            suggestable_attributes: "Suggestable Attributes",
            min_qty: "Minimum Quantity",
            prod_min: "Production Minimum",
            sample_max_qty: "Sample: Maximum Quantity",
            sample_order_form_max_qty: "Sample: Order Form Maximum Quantity",
            sample_ring_set_max_qty: "Sample: RingSet Maximum Quantity",
            sample_guest_price: "Sample: Guest Price",
            sample_professional_price: "Sample: Professional Price",
            sample_out_of_stock_limit: "Sample: Out of Stock Limit",
            group_sample_out_of_stock_limit: "Group Sample: Out of Stock Limit",
            free_shipping_sample_professional: "Free Shipping Sample Professional",
            sample_reminder_days: "Sample Reminder Days",
            complete_order_days: "Complete Order Days",
            session_cookie_name: "Session Cookie Name",
            sku_list: "SKU List",
            freight_chart: "Freight Chart",
            hanging_sequence: "Hanging Sequence",
            order_commitment_form: "Order Commitment Form",
            nys_resale_certificate: "NYS Resale Certificate",
            ct_resale_certificate: "CT Resale Certificate",
            presentation_cut_form: "Presentation Cut Form",
            wire_transfer_instructions: "Wire Transfer Instructions",
            freight_base_price: "Freight Base Price",
            freight_price_per_item: "Freight Price Per Item",
            sample_base_price: "Sample Base Price",
            sample_price_per_item: "Sample Price Per Item",
            cfa_base_price: "CFA Base Price",
            cfa_name: "CFA Name",
            cfa_description: "CFA Description",
            title: "Title",
            front_url_title: "Front Url Title",
            front_url: "Front Url",
            admin_url: "Admin Url",
            aws_cloud_front_url: "AWS Cloud Front Url",
            facebook: "Facebook",
            pinterest: "Pinterest",
            instagram: "Instagram",
            email: "Email",
            street_address: "Street Address",
            state: "State",
            phone: "Phone",
            city: "City",
            zipcode: "Zipcode",
            admin_emails: "Admin Emails",
            fabric_emails: "Fabric Emails",
            sample_emails: "Sample Emails",
            option: {
                regular: "Regular",
                expedited: "Expedited",
                own_account: "Own Account",
                free: "Free",
                "attributes.color_range": "attributes.color_range",
                "attributes.color_nb": "attributes.color_nb",
                name: "name",
                sku: "sku",
                supplierSku: "supplierSku",
                "parent.description": "parent.description",
                "parent.name": "parent.name",
                "name.suggest": "name.suggest",
                "parent.description.suggest": "parent.description.suggest",
                "parent.name.suggest": "parent.name.suggest",
                "parent.sku": "parent.sku",
                "parent.attributes.tags": "parent.attributes.tags",
                "parent.attributes.brand": "parent.attributes.brand",
                "parent.attributes.collection_name": "parent.attributes.collection_name",
                "parent.attributes.fabric_type": "parent.attributes.fabric_type",
                "parent.attributes.fabric_use": "parent.attributes.fabric_use",
                "parent.attributes.performance": "parent.attributes.performance",
                "parent.millName": "parent.millName",
                title: "title",
                slug: "slug",
                content: "content"         
            }
        }
    },
};

export default customEnglishMessages;
